import types            from './types';
import { initialState } from '../../../App';

const userSupport = (state = {}, action) => {
  switch (action.type) {
    case types.CLEAR:
    {
      return {
        ...state, ...initialState.userSupport,
      };
    }
    case types.START_FETCH:
    {
      return {
        ...state,
        loading: true,
      };
    }
    case types.END_FETCH:
    {
      const { error, payload } = action;
      return {
        ...state,
        loading: false,
        error: error ? payload : null,
      };
    }
    case types.UPDATE_TRANSACTIONS_CLAIM:
    {
      const { data: { currency, totalList, listClaim } } = action.payload;
      return {
        ...state,
        transactionsClaim: {
          currency,
          totalElements: totalList,
          list: listClaim || [],
        },
      };
    }
    case types.UPDATE_TRANSACTIONS_CLAIM_EXCEL:
    {
      const { headers, title, rows } = action.payload;
      return {
        ...state,
        transactionsClaimExcel: {
          title,
          headers,
          rows: rows || [],
        },
      };
    }
    case types.UPDATE_TRANSACTIONS_COMMISSION:
    {
      const { payload, payload: { data: { count_transactions, transactions } } } = action;
      return {
        ...state,
        transactionsCommission: {
          totalElements: count_transactions,
          list: transactions || [],
        },
      };
    }
    case types.UPDATE_TRANSACTIONS_COMMISSION_EXCEL:
    {
      const { headers, title, rows } = action.payload;
      return {
        ...state,
        transactionsCommissionExcel: {
          title,
          headers,
          rows: rows || [],
        },
      };
    }
    case types.UPDATE_TRANSACTION_TYPES :
      {
        const { data } = action.payload;
        return {
          ...state,
          transactionsTypes: data,
        };
      }
    default:
      return state;
  }
};

export default userSupport;
